/**
 * Formats a snake_case service type string to Title Case.
 * Example: 'search_console' → 'Search Console'
 */
export const formatServiceType = (serviceType: string): string =>
  serviceType
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
